import Request from 'models/Request'

export const hasRequestError = (key) => {
  return Request.hasErrorFetch(key)
}
